import styled from "styled-components"

export const EmptyCartContainer = styled.div`
    height: 500px;
    width: 100%;
    background-color: #e5e5e5;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const EmptyCartMessage = styled.h1`
    opacity: 0.7;
`

export const Img = styled.img`
    width: 100%;
    height: 100%;
`

export const SadImageContainer = styled.div`
    width: 70px;
    height: 70px;
    margin-left: 10px;
    display: flex;
    align-items: center;
    object-fit: contain;
    justify-content: center;
    opacity: 0.7;
`